import React from "react"
import './styles.scss'
import ImgComponent, { LOADING_IMG } from "../../../../HOCs/ImageHocs"
import classNames from "../../../../utils/classnameUtils"
import { IMAGE_CROP_MODES } from "../../../shared/constants"
import { IMAGE_MODE } from "../../../../constants/imageMode"
import { getContentImageByMode, getUrlUnityImageApi } from "../../../../utils/imageUtils"
import TrailerVideo from "../TrailerVideo"
import { Button, ProgressBar } from "react-bootstrap"

const TrailerOverview = ({
  content,
  videoSource,
  TRAILER_REF,
  prefixNetworkText,
  onClickSelectedContentButton,
  handleMyListrFromTrailer,
  handlePlayerFromTrailer,
  favorites,
  authenticated
}) => {

  const [videoBool, setVideoBool] = React.useState(false);
  const [imageBool, setImageBool] = React.useState((true));
  const [myListBool, setMyListBool] = React.useState((false));
  const [muted, setMuted] = React.useState((true));


  React.useEffect(() => {
    if (TRAILER_REF?.current) {
      setVideoBool(true)
    }
  }, [TRAILER_REF])

  React.useEffect(() => {
    if (Array.isArray(favorites)) {
      setMyListBool(favorites.some((e) => e === content.id))
    }
  }, [favorites])

  /*const handleContentFromTrailer = (event) => {
    event.stopPropagation();
    onClickSelectedContentButton()
  }*/

  const imageData = getContentImageByMode(content.images, IMAGE_MODE.THUMB);
  const imageSrc = (imageData && imageData.url);

  const onChangeMuted = (event) => {
    event.stopPropagation();
    if (TRAILER_REF?.current) {
      TRAILER_REF.current.firstElementChild.muted = !TRAILER_REF.current.firstElementChild.muted;
      setMuted(TRAILER_REF.current.firstElementChild.muted)
    }
  }

  return (
    <div className={classNames('trailerOverview')} >
      <div className="trailerOverview_container">
        {<figure className={classNames('tbxContentCard__content-image', 'tbxContentCard__aspect-ratio', 'trailerOverview__content-image')}
          style={{ position: 'relative', '--aspect-ratio': 16 / 9, overflow: 'hidden', margin: '0px', height: 'auto', transform: 'scale(1)' }}>
          {/* IMG */}
          {!videoBool && imageBool &&
            <ImgComponent
              className={classNames('tbxContentCard__image', 'trailerOverview__image')}
              alt={`trailerOverview-img-content-${content.id || content.externalId}`}
              src={getUrlUnityImageApi(imageSrc)}
              crop={IMAGE_CROP_MODES.resizeScaleAndCrop}
              size={IMAGE_MODE.THUMB}
              loading={LOADING_IMG.EAGER}
              width={'100%'}
              height={'100%'}
              setimagebool={(e) => setImageBool(e)}
            />
          }
          {!!videoSource && <TrailerVideo
            videoSource={videoSource}
            content={content}
            trailerRef={TRAILER_REF}
          />}
          {!!videoSource && <Button className="trailerOverview_muted" onClick={(event) => onChangeMuted(event)}>
            {muted ?
              <i className="bi bi-volume-mute-fill" /> :
              <i className="bi bi-volume-up-fill" />
            }
          </Button>}
          {(typeof content?.bookmark?.position === 'number') && <div className={classNames("tbxContentCard__data-inner","trailerOverview_data-inner")}>
            {(typeof content?.bookmark?.position === 'number') &&
              <ProgressBar className={classNames("tbxContentCard__data-inner_progressBar", "trailerOverview_progressBar")} now={content.bookmark.position} max={content.duration} />}
          </div>}
        </figure>}
        <div className="trailerOverview__body">
          <div className="trailerOverview__buttons">
            <div className="trailerOverview__buttons_sectionOne">
              <Button className="trailerOverview__buttons_play" onClick={(event) => handlePlayerFromTrailer(event)}>
                <i className="bi bi-play-circle" />
              </Button>
              {authenticated && <Button className="trailerOverview__buttons_favorite" onClick={(event) => handleMyListrFromTrailer(event)}>
                {myListBool ? <i className="bi bi-check-circle" /> : <i className="bi bi-plus-circle" />}
              </Button>}
            </div>
            {/*<div className="trailerOverview__buttons_sectionTwo">
              <Button className="trailerOverview__buttons_content" onClick={(event) => handleContentFromTrailer(event)}>
                <i className="bi bi-info-circle-fill" />
              </Button>
          </div>*/}

          </div>
          <div className="trailerOverview__data">
            {content.title && <h3 className="trailerOverview__data-title">{content.title}</h3>}
            {(content.networks) &&
              <p className="trailerOverview__data-subtitle">
                {`${prefixNetworkText}`}{content.networks.map((network) => network.name)}
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrailerOverview;